import { Pagination, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { useEffect, useState } from '@wordpress/element';
import { API } from '../API';
import EntidadesItem from '../EntidadesItem';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay'; // - styles required for Autoplay module
import FormSearchEntidades from '../FormSearchEntidades';


function SliderEntidades({ displaySearchForm, perSlide, filterEntidades }) {

  const apiEntidades = new API({ filterEntidades });
  const defaultArgs = {
    posts_per_page: 99,
  }

  const [totalEntidades, setTotalEntidades] = useState(0);
  const [originalEntidades, setOriginalEntidades] = useState([]);
  const [entidadesQuery, setEntidadesQuery] = useState();
  const [allEntidades, setAllEntidades] = useState([]);
  const searchEntidades = (event) => {
    
    event.preventDefault();
    
    if (!entidadesQuery) {
      setTotalEntidades(originalEntidades.length);
      setAllEntidades(originalEntidades);
      return;
    }
    
    const searchQuery = { ...defaultArgs, search: entidadesQuery };

    apiEntidades.loadContent(searchQuery).then(response => {
      setTotalEntidades(response.data.length);
      setAllEntidades(response.data)
    });

  }

  useEffect(() => {

    apiEntidades.loadContent(defaultArgs).then(response => {
      setOriginalEntidades(response.data);
      setTotalEntidades(response.data.length);
      setAllEntidades(response.data);
    });

  }, []);

  return (
    <>
      
      { displaySearchForm === 'true' && <FormSearchEntidades className="pt-2" searchEntidades={searchEntidades} setEntidadesQuery={setEntidadesQuery} /> }

      <Swiper
        className={ displaySearchForm === 'false' ? 'mt-2' : '' }
        modules={[Pagination, A11y, Autoplay]}
        spaceBetween={32}
        
        slidesPerView={perSlide}
        slidesPerGroup={perSlide}
        breakpoints={{
          320: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: perSlide,
            slidesPerGroup: perSlide,
            spaceBetween: 16,
          },
        }}
        loop={true}
        navigation
        pagination={{ 
          clickable: true 
        }}
        scrollbar={{ draggable: true }}
      >
        {allEntidades.map(item => {
          return (
            <SwiperSlide key={item.id}>
              <EntidadesItem id={item.id} title={item.title} logo={item.logo} external_link={item.external_link} />
            </SwiperSlide>
          )
        })}
      </Swiper>
    </>
  );
}

export default SliderEntidades;